import { render } from "./ModalViewImages.vue?vue&type=template&id=05a9174d"
import script from "./ModalViewImages.vue?vue&type=script&lang=js"
export * from "./ModalViewImages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__